import zxcvbn from 'zxcvbn';

/**
 * passwordIndication goal is to deliver information on how to make a password strong enough.
 */
function passwordIndication(password: string): string[] {
	const AtLeastOneUpperCase = new RegExp('^(?=.*[A-Z])');
	const AtLeastOneLowerCase = new RegExp('^(?=.*[a-z])');
	const AtLeastOneNumber = new RegExp('^(?=.*[0-9])');
	const AtLeastOneSpecial = new RegExp('^(?=.*[^a-zA-Z0-9])');
	const isNewPwdWithAtLeastOneUpperCase = !AtLeastOneUpperCase.test(password);
	const isNewPwdWithAtLeastOneLowerCase = !AtLeastOneLowerCase.test(password);
	const isNewPwdWithAtLeastOneNumber = !AtLeastOneNumber.test(password);
	const isNewPwdWithAtLeastOneSpecial = !AtLeastOneSpecial.test(password);
	let errorListing: Array<string> = [];
	isNewPwdWithAtLeastOneUpperCase &&
		errorListing.push('le mot de passe ne contient pas de majuscule');
	isNewPwdWithAtLeastOneLowerCase &&
		errorListing.push('le mot de passe ne contient pas de minuscule');
	isNewPwdWithAtLeastOneNumber &&
		errorListing.push('le mot de passe ne contient pas de chifre');
	isNewPwdWithAtLeastOneSpecial &&
		errorListing.push(
			'le mot de passe ne contient pas de caractères spéciaux (!@#$%^&*)'
		);

	return errorListing;
}

function passwordChecker(
	p1: string,
	p2: string,
	lengthmin: number,
	strengthmin: number
): boolean {
	const isSamePwd = passwordStrictIdentical(p1, p2);
	const strength = zxcvbn(p1).score;

	return isSamePwd && strength > strengthmin && p1.length > lengthmin;
}

function passwordStrictIdentical(p1: string, p2: string): boolean {
	return p1 === p2;
}

export { passwordIndication, passwordChecker, passwordStrictIdentical };
